import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";

function CreateDeckDialog({
  open,
  deckForm,
  onClose,
  onCreateDeck,
  onUpdateDeckForm,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      PaperProps={{
        sx: {
          borderRadius: { xs: "18px", sm: "22px" },
          bgcolor: "var(--toeic-surface)",
          boxShadow: "0 26px 60px -32px rgba(19, 43, 63, 0.55)",
          m: { xs: 1.5, sm: 3 },
        },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Typography sx={{ color: "var(--toeic-ink-deep)", fontWeight: 700, fontSize: 20 }}>
          Create deck
        </Typography>
        <Typography sx={{ color: "var(--toeic-ink-soft)", fontSize: 13, fontWeight: 500 }}>
          Build a vocabulary set and decide whether to share it publicly.
        </Typography>
      </DialogTitle>
      <DialogContent sx={{ pt: "8px !important", pb: 2 }}>
        <Box component="form" onSubmit={onCreateDeck} sx={{ display: "grid", gap: 1.5 }}>
          <TextField label="Deck name" value={deckForm.name} onChange={onUpdateDeckForm("name")} fullWidth autoFocus />
          <TextField label="Description" value={deckForm.description} onChange={onUpdateDeckForm("description")} fullWidth multiline minRows={2} />
          <TextField label="Tags, separated by commas" value={deckForm.tags} onChange={onUpdateDeckForm("tags")} fullWidth />
          <FormControlLabel
            control={<Switch checked={deckForm.isPublic} onChange={onUpdateDeckForm("isPublic")} />}
            label="Publish deck for everyone"
          />
          <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ pt: 0.5 }}>
            <Button type="button" onClick={onClose} sx={{ borderRadius: "999px" }}>
              Cancel
            </Button>
            <Button type="submit" variant="contained" startIcon={<AddIcon />} sx={{ borderRadius: "999px", bgcolor: "#6d4aff", "&:hover": { bgcolor: "#5635d6" } }}>
              Create deck
            </Button>
          </Stack>
        </Box>
      </DialogContent>
    </Dialog>
  );
}

export default CreateDeckDialog;
